import Vue from 'vue'
import store from '../store/index'
import moment from "moment"

Vue.filter("languageLookup", function (abbreviation) {
  let language = _.find(store.state.app.languages, { code: abbreviation })
  if (!language) {
    return language
  }
  return language.language
})

Vue.filter("formatDate", function (date) {
  return moment(date).lang("nl").fromNow()
})

Vue.filter("formatDateText", function (date) {
  return moment(date).lang("nl").format("DD/MMM")
})

Vue.filter('ucfirst', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('lowercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
})

Vue.filter('capitalize', function (value) {
  if (!value) return ""
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('shorten', function (value) {
  if (!value) return ""
  return value.length > 40 ? value.substring(0, 40) + "..." : value
})

Vue.filter('veryshorten', function (value) {
  if (!value) return ""
  return value.length > 25 ? value.substring(0, 25) + "..." : value
})

Vue.filter("removeExtraInfo", function (value) {
  if (!value) return ""
  return value.replace("<extrainfo>", "").replace("</extrainfo>", "")
})
